import { color } from "@/styles/theme";
import React, { ReactNode } from "react";

export const PlanBoxFooter = ({ children }: { children: ReactNode }) => {
  return (
    <div css={{ backgroundColor: color.gray50, padding: "16px" }}>
      {children}
    </div>
  );
};
